<!-- 作业列表 -->
<template>
  <div v-loading="loading">
    <el-table :data="homeworkList">
      <el-table-column prop="studentName" label="组长/学生名称"></el-table-column>
      <el-table-column prop="groupNo" label="小组编号"></el-table-column>
      <el-table-column prop="licenseNo" label="学号"></el-table-column>
      <el-table-column prop="status">
        <template slot="header" slot-scope="scope">
          <el-select v-model="paramCourseWork.status" style="width:120px;" @change="ngOnInit">
            <el-option label="全部" :value="0"></el-option>
            <el-option label="未提交" :value="1"></el-option>
            <el-option label="已提交" :value="2"></el-option>
            <el-option label="已批改" :value="3"></el-option>
          </el-select>
        </template>
        <template slot-scope="scope">
          <span v-if="scope.row.status==1">未提交</span>
          <span v-if="scope.row.status==2">已提交</span>
          <span v-if="scope.row.status==3">已批改</span>
        </template>
      </el-table-column>
      <el-table-column prop="committedDate" label="提交时间"></el-table-column>
      <el-table-column prop="score" label="分数"></el-table-column>
      <!-- <el-table-column label="应用软件">
        <template slot-scope="scope">
          <span v-if="scope.row.softwareType == 1">AT</span>
          <span v-if="scope.row.softwareType == 2">AFM</span>
        </template>
      </el-table-column>-->
      <!-- <el-table-column prop="courseWareId" label="课程ID"></el-table-column> -->
      <el-table-column label="操作" width="300">
        <template slot-scope="scope">
          <div>
            <el-button
              type="primary"
              size="small"
              style="margin-right: 10px;"
              @click="details(scope.row)"
              :disabled="scope.row.status==1"
            >查看详情</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- <el-pagination
          class="foot-pager"
          :page-size="10"
          :pager-count="11"
          layout="prev, pager, next"
          :total="total"
          :current-page.sync="paramCourseWork.startIndex"
          @current-change="ngOnInit"
    ></el-pagination>-->
  </div>
</template>

<script>
import richEditor from "@/components/common/RichEditor.vue";
export default {
  components: {
    richEditor,
  },
  data() {
    return {
      total: 0,
      homeworkList: [],
      loading: false,
      paramCourseWork: {
        courseWorkId: this.$route.query.courseWorkId,
        schoolId: this.$route.query.schoolId,
        status: 0,
      },
    };
  },
  created() {
    this.ngOnInit();
  },
  methods: {
    // 详情
    details(item) {
      this.$emit("onDetails", item);
    },
    // 页面初始化
    ngOnInit() {
      this.loading = true;
      this.$api.allianceSchool
        .queryWorkFinishStatus(this.paramCourseWork)
        .then((res) => {
          this.loading = false;
          if (res.errCode == 0) {
            this.homeworkList = res.data || [];
            // this.total = res.total;
          } else {
            this.$message.error(res.errMsg);
          }
        })
        .catch((res) => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang='less' scoped>
.foot-pager {
  text-align: center;
}
</style>